import MatchHeight from 'vanilla-js-match-height'

export default function Heights() {
	new MatchHeight('.js-banner-heading')
	new MatchHeight('.js-banner-content')
	new MatchHeight('.js-banner-wrapper')

	new MatchHeight('.js-category-heading')
	new MatchHeight('.js-category-description')
	new MatchHeight('.js-category-item')

	new MatchHeight('.js-card-heading', {
		byRow: true,
	})

	new MatchHeight('.js-card-content',{
		byRow: true,
	})

	new MatchHeight('.js-case-study-item', {
		byRow: true
	})

	new MatchHeight('.js-inspiration-heading')

	new MatchHeight('.js-post-meta')
	new MatchHeight('.js-post-heading')
	new MatchHeight('.js-post-excerpt')
	new MatchHeight('.js-post-item')

	new MatchHeight('.js-product-title')
	new MatchHeight('.js-product-desc')

	new MatchHeight('.js-product-archive-item', {
		byRow: false
	})

	new MatchHeight('.js-grid-item')
	new MatchHeight('.js-grid-heading')
	new MatchHeight('.js-grid-content')

	new MatchHeight('.js-feature-heading', {
		byRow: false
	})
	new MatchHeight('.js-feature-content', {
		byRow: false
	})

	new MatchHeight('.js-model-feature-item')

	new MatchHeight('.js-timeline-heading')

	new MatchHeight('.js-statistic-icon')
	new MatchHeight('.js-statistic-value')
	new MatchHeight('.js-statistic-content')

	new MatchHeight('.js-search-title', {
		byRow: false
	})

	new MatchHeight('.js-literature-heading')
	new MatchHeight('.js-literature-guides')

	new MatchHeight('.js-team-heading')
	new MatchHeight('.js-team-desc')

}
